var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-cadastro" },
    [
      _c("div", { staticClass: "card-header marginTitle" }, [
        _c("h1", [_vm._v(_vm._s(_vm.titleCadastro))])
      ]),
      _c(
        "div",
        { staticClass: "content" },
        [
          !_vm.isIntroPasso && !_vm.isResumo
            ? _c(
                "el-tabs",
                {
                  attrs: { value: _vm.menu },
                  on: { "tab-click": _vm.mudarTab }
                },
                [
                  _vm._l(_vm.tabs, function(tab) {
                    return tab.label != "Resumo"
                      ? [
                          _c("el-tab-pane", { attrs: { name: tab.name } }, [
                            _c(
                              "span",
                              {
                                staticClass: "tab",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(_vm._s(tab.label) + "  "),
                                _vm.tabPossuiErro(tab.label)
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "light",
                                          placement: "bottom"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content"
                                          },
                                          _vm._l(
                                            _vm.getErrosTab(tab.label),
                                            function(erro) {
                                              return _c("p", [
                                                _c("pre", [
                                                  _vm._v(_vm._s(erro))
                                                ])
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "el-icon-warning tooltip-icon"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ]
                      : _vm._e()
                  })
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "container-tab" },
            [
              _c(
                "validation-observer",
                { ref: "observer", attrs: { tag: "form" } },
                [
                  _c(
                    "keep-alive",
                    [
                      !_vm.isLoading
                        ? _c("router-view", {
                            attrs: {
                              cadastro: _vm.cadastroJson,
                              idCadastro: _vm.idCadastro,
                              observer: this.$refs.observer
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-buttons-cadastro-sicarf", {
        attrs: {
          isPrimeiroPasso: _vm.isPrimeiroPasso,
          isUltimoPasso: _vm.isResumo,
          isIntroPasso: _vm.isIntroPasso,
          showButtonProximo: !_vm.isResumo,
          showButtonSalvar: !_vm.isIntroPasso && !_vm.isResumo
        },
        on: {
          proximo: _vm.proximo,
          salvar: _vm.salvarCadastro,
          voltar: _vm.voltar,
          cancelar: _vm.cancelar,
          finalizar: _vm.openTermoCompromisso
        }
      }),
      _vm.showTermoCompromisso
        ? _c("termo-compromisso-sicarf", {
            on: {
              confirmar: _vm.finalizarCadastro,
              cancelar: function() {
                return (this$1.showTermoCompromisso = false)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15f9d60f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15f9d60f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/CadastroSicarf.vue
// module id = null
// module chunks = 